import React, { useEffect, useState } from 'react'
import ReactPlayer from 'react-player'
import Videos from './Videos'
import { fetchFromAPI } from '../utils/fetchFromAPI'
import { Box, Stack, Typography } from '@mui/material'
import { useParams } from 'react-router-dom'
const VideoDetail = () => {
    const [videoDetail, setVideoDetail] = useState(null)
    const {id} = useParams()
    useEffect(() => {
        fetchFromAPI(`videos?part=snippet,statistics&id=${id}`).then((data) => setVideoDetail(data.items[0]))
    },[id])
  return (
    <Box minHeight='95vh'>
        <Stack direction={{xs: 'column', md: 'row'}}> 
            <Box sx={{width: '100%', position: 'sticky', top:'86px' }}>
                <ReactPlayer url = {`https://www.youtube.com/watch?v=${id}`} 
                className="react-player" controls></ReactPlayer>
                <Typography color='#fff' variant='h5' fontWeight="bold" p={2}>
                    {videoDetail?.snippet?.title}
                </Typography>
                <Stack direction='row-reverse' justifyContent='space-between' sx={{color: '#fff'}}
                py={1} px={2}>
                    <Typography variant='body1' sx={{opacity: 0.7}}>
                        {videoDetail?.statistics?.viewCount || 'None'} Views
                    </Typography>
                </Stack>
            </Box>
        </Stack>
    </Box>
  )
}

export default VideoDetail